import { useDispatch } from 'react-redux'
import { ErrorResponse, SuccessResponse } from './apiTypes'

export function useApiCall() {
    const dispatch = useDispatch()

    const callApi = <P, R>(sagaAction: string, dataOrParams: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        dispatch({
            type: sagaAction,
            payload: dataOrParams,
            onSuccess,
            onError,
        })
    }

    return callApi
}
